module.exports = __webpack_public_path__ + "img/product-category-eternityrings@2x.2fbbf85.jpg";